import { render, staticRenderFns } from "./EmbedOmnichannelSDK.vue?vue&type=template&id=59e87ac7&scoped=true"
import script from "./EmbedOmnichannelSDK.vue?vue&type=script&lang=js"
export * from "./EmbedOmnichannelSDK.vue?vue&type=script&lang=js"
import style0 from "./EmbedOmnichannelSDK.vue?vue&type=style&index=0&id=59e87ac7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e87ac7",
  null
  
)

export default component.exports